export default {"src":"https://images-cdn.curipod.com/d-bdb94e66/_next/static/media/clap.d22e6eb2.svg","height":156,"width":145};